import React from 'react';
import { Autocomplete, Skeleton, TextField } from '@mui/material';
import { useApiGet } from '../utils/httpClient';
import { getCountries } from '../endpoints/lookups';

export default function CountrySelector({
  handleChange,
  size = 'small',
  error = null,
  errorMessage = null,
  value,
  required = true,
  disabled = false,
}) {
  const {
    data: countries,
    isPending,
    isError,
    error: fetchError,
  } = useApiGet(['donation-countries'], getCountries, {
    enabled: true,
  });

  let label = 'Country';
  if (required) {
    label = 'Country *';
  }

  if (isPending) {
    return (
      <Skeleton variant="rounded" height={40} aria-label="Loading countries" />
    );
  }

  if (isError) {
    return (
      <TextField
        label={label}
        size={size}
        fullWidth
        variant="standard"
        disabled
        error
        helperText={
          fetchError?.message
            ? `Could not load countries: ${fetchError.message}`
            : 'Could not load countries. Refresh the page or try again later.'
        }
      />
    );
  }

  if (!countries?.length) {
    return (
      <TextField
        label={label}
        size={size}
        fullWidth
        variant="standard"
        disabled
        error
        helperText="No countries are available. Refresh the page or contact support."
      />
    );
  }

  return (
    <Autocomplete
      size={size}
      onChange={(event, newValue) => handleChange(newValue)}
      getOptionLabel={(option) => option.name}
      variant="standard"
      value={
        countries.find((option) => option.id === value)
          ? countries.find((option) => option.id === value)
          : null
      }
      label={label}
      options={countries}
      disabled={disabled}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          error={error}
          helperText={error ? errorMessage : ''}
        />
      )}
    />
  );
}
